import { SWRConfiguration } from 'swr';

import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';
import { Enum } from '../enums';

export const SWR_KEY_CUSTOM_FIELD_TRANSLATIONS =
  'getCustomEmployeeFieldTranslations';

export const getCustomEmployeeFieldTranslations = (
  strLangs: string[],
  includeInactive = false,
): Promise<Enum[][]> => {
  return Promise.all(
    strLangs.map((strLang) =>
      fetchFromOldApi(
        `/json/enum/CUSTOM_ENTITY_EMPLOYEE/${strLang}?includeInactive=${includeInactive}`,
      ).then((r) => r.json()),
    ),
  );
};

export const useCustomFieldTranslations = (
  strLangs: string[],
  includeInactive = false,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
): UseArraySWROutput<Enum[]> => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  return useArraySWR<Enum[]>(
    !isDisabled && isCustomDataEnabled
      ? [SWR_KEY_CUSTOM_FIELD_TRANSLATIONS, strLangs, includeInactive]
      : null,
    ([langs, includeInactive]: [langs: string[], includeInactive: boolean]) =>
      getCustomEmployeeFieldTranslations(langs, includeInactive),
    swrConfig,
  );
};
